var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WorkspaceCreate',{directives:[{name:"show",rawName:"v-show",value:(_vm.step == 1),expression:"step == 1"}],on:{"changeStep":_vm.changeStep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }